








































import { defineComponent } from '@vue/composition-api';
import { ExclamationIcon, InformationCircleIcon, XCircleIcon } from '@vue-hero-icons/outline';

export default defineComponent({
    name: 'GeneralAlert',
    props: {
        text: {
            type: String,
        },
        actionTitle: {
            type: String,
            default: '',
        },
        actionCallback: {
            type: Function,
            default: () => {
                return null;
            },
        },
        hasLoader: {
            type: Boolean,
            default: false,
        },
        alertType: {
            type: String,
            // default: 'danger',
            validator: (value: string) => ['danger', 'info', 'warning'].indexOf(value) >= 0,
        },
    },
    components: { ExclamationIcon, InformationCircleIcon, XCircleIcon },
    setup() {
        const areaClasses = {
            danger: 'bg-red-100 border-red-500',
            info: '  border-blue-400 bg-blue-100',
            warning: 'border-yellow-400 bg-yellow-50',
        };
        const textClasses = {
            danger: 'text-red-500',
            info: 'text-blue-500',
            warning: 'text-yellow-700',
        };
        const baseColorClasses = {
            danger: '#f56565',
            info: '#4299e1',
            warning: '#ecc94b',
        };

        return { textClasses, areaClasses, baseColorClasses };
    },
});
